import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Header from "./components/header/Header";
import { Outlet, useLocation } from "react-router-dom";
import "./layout.scss";
import ProgressiveLoader from "./components/loader/ProgressiveLoader";
import { isPhoneJs } from "./utlis/resolution";
import { USER_LIST } from "./routes/routerPath";

const Layout = () => {
  const location = useLocation();
  const loader = useSelector((state) => state.global.loading);
  const [header, setHeader] = useState(isPhoneJs());
  const [path, setPath] = useState(location.pathname);
  useEffect(() => {
    const handleResize = () => {
      setHeader(isPhoneJs());
    };
    window.addEventListener("resize", handleResize);
    // Clean up the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);
  const headerHandler = () => {
    if (header && path !== USER_LIST) {
      return false;
    }
    return true;
  };
  return (
    <div className="layout-wrapper">
      {headerHandler() && <Header />}
      <Outlet />
      {loader && <ProgressiveLoader loader={loader} />}
    </div>
  );
};

export default Layout;
